// extracted by mini-css-extract-plugin
export default {"contactDetailsError":"ContactDetails_contactDetailsError__aFLV6"};